import { AvatarConfig } from "../avatar/common/player/type";
import { ResourceType } from "../base/loader/type";
import { SmartScenarioBuilders } from "../avatar/common/player/util";
import { defaultConfig } from "./default.config";
import type { CameraConfig } from '../base/camera/type';
import type { LightingConfig } from '../base/light/type';
import type { RendererConfig } from '../base/renderer/type';
import type { LoaderConfig } from '../base/loader/type';
import type { ScenarioConfigs } from '../avatar/common/animation/type';

/**
 * Bambam 리소스 설정 (Placeholder)
 *
 * TODO: bambam GLB 파일과 애니메이션이 추가되면 업데이트 필요
 * - /glb/avatars/bm_avatar_bambam_00001.glb
 * - /glb/animations/bambam/*.glb
 */
export const bambamResources: ResourceType[] = [
  // Placeholder - 실제 GLB 파일이 추가되면 업데이트
  {
    name: "bambam",
    type: "model_only",
    path: "/glb/avatars/nn_avatar_nani_00001.glb", // Fallback to nalnani
    format: "glb"
  },
];

/**
 * Bambam 시나리오 설정 (Placeholder)
 */
const BAMBAM_SCENARIOS: ScenarioConfigs<string> = {
  entrance: {
    animations: [],
    playMode: 'once',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "Placeholder entrance animation",
    animationPattern: 'single'
  },

  waiting: {
    animations: [],
    playMode: 'loop',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "Placeholder waiting animation",
    animationPattern: 'single'
  },

  listening: {
    animations: [],
    playMode: 'loop',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "Placeholder listening animation",
    animationPattern: 'single'
  },

  processing: {
    animations: [],
    playMode: 'loop',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "Placeholder processing animation",
    animationPattern: 'single'
  },

  speaking: {
    animations: [],
    playMode: 'loop',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "Placeholder speaking animation",
    animationPattern: 'single'
  },

  error: {
    animations: [],
    playMode: 'once',
    selectionMode: 'none',
    blendDuration: 0.2,
    description: "Placeholder error animation",
    animationPattern: 'single'
  }
};

// 카메라 설정
const bambamCameraConfig: CameraConfig = {
  ...defaultConfig.camera
};

// 조명 설정
const bambamLightConfig: LightingConfig = {
  ...defaultConfig.lighting,
  lights: []
};

// 렌더러 설정
const bambamRendererConfig: RendererConfig = {
  ...defaultConfig.renderer,
  renderer: {
    ...defaultConfig.renderer.renderer,
  }
};

const bambamLoaderConfig: LoaderConfig = {
  ...defaultConfig.loader,
};

export const bambamAvatarConfig: AvatarConfig = {
  type: 'bambam' as const,
  modelKey: 'bambam',
  resources: bambamResources,
  scenarioConfigs: BAMBAM_SCENARIOS,
  scale: { x: 1, y: 1, z: 1 },
  bloom: {
    emissiveIntensity: 20,
    meshNames: [],
    specialSettings: {
      applySpecularEffect: true,
      transmission: 1,
      roughnessMultiplier: 0.8,
    }
  },
  lipsync: {
    indices: [],
    processingType: 'range_mapping',
    config: {
      sourceIndex: 0,
      targetMappings: [],
      resetIndices: [],
    }
  }
};

// Bambam 통합 설정 인터페이스
export interface BambamConfig {
  loader: LoaderConfig;
  camera: CameraConfig;
  lighting: LightingConfig;
  renderer: RendererConfig;
  avatar: AvatarConfig;
}

/**
 * Bambam 설정 통합 객체
 */
export const bambamConfig: BambamConfig = {
  loader: bambamLoaderConfig,
  camera: bambamCameraConfig,
  lighting: bambamLightConfig,
  renderer: bambamRendererConfig,
  avatar: bambamAvatarConfig
};
